module.exports = __webpack_public_path__ + "img/大冰箱.c747f73d.webp";